import * as React from "react"
import "./Login.scss"
import { HOME } from "constants/paths"
import phronesisLogo from "assets/images/logo-phronesis.svg"
import { Link } from "react-router-dom"

import { Grid, GridColumn } from "@walmart-web/livingdesign-components"
import LoginForm from "components/Login/LoginForm/LoginForm"
import LoginLanguageSelector from "components/Login/LoginLanguageSelector/LoginLanguageSelector"

const Login: React.FC = (): JSX.Element => {
	const className = "login"
	return (
		<React.Fragment>
			<Grid className={`${className}-page-body`}>
				<GridColumn sm={12} md={3} className={`${className}-side-panel`}>
					<Link to={HOME}>
						<img
							src={phronesisLogo}
							alt="Phronesis Logo"
							className={`${className}-logo`}
						/>
					</Link>
				</GridColumn>

				<GridColumn sm={12} md={9} className={`${className}-content`}>
					<LoginLanguageSelector />
					<LoginForm />
				</GridColumn>
			</Grid>
		</React.Fragment>
	)
}

export default Login
